var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.8 20 8 19.2 8 18C8 10.2 14.2 4 22 4C28 4 33.4 8 35.4 13.8C35.6 14.8 35.2 16 34 16.2C33 16.6 31.8 16 31.4 15C30.2 10.8 26.4 8 22 8C16.4 8 12 12.4 12 18C12 19.2 11.2 20 10 20Z",
    fill: "#425466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36C34.8 36 34 35.2 34 34C34 32.8 34.8 32 36 32C40.4 32 44 28.4 44 24C44 19.6 40.4 16 36 16C35.4 16 34.6 16 34 16.2C33 16.4 31.8 15.8 31.6 14.8C31.4 13.8 32 12.6 33 12.4C34 12.2 35 12 36 12C42.6 12 48 17.4 48 24C48 30.6 42.6 36 36 36ZM16 36H10C8.8 36 8 35.2 8 34C8 32.8 8.8 32 10 32H16C17.2 32 18 32.8 18 34C18 35.2 17.2 36 16 36Z",
    fill: "#425466"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36H32C30.8 36 30 35.2 30 34C30 32.8 30.8 32 32 32H36C37.2 32 38 32.8 38 34C38 35.2 37.2 36 36 36ZM10 36C4.4 36 0 31.6 0 26C0 20.4 4.4 16 10 16C11.2 16 12 16.8 12 18C12 19.2 11.2 20 10 20C6.6 20 4 22.6 4 26C4 29.4 6.6 32 10 32C11.2 32 12 32.8 12 34C12 35.2 11.2 36 10 36ZM24 44C22.8 44 22 43.2 22 42V22C22 20.8 22.8 20 24 20C25.2 20 26 20.8 26 22V42C26 43.2 25.2 44 24 44Z",
    fill: "#425466"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30C17.4 30 17 29.8 16.6 29.4C15.8 28.6 15.8 27.4 16.6 26.6L22.6 20.6C23.4 19.8 24.6 19.8 25.4 20.6C26.2 21.4 26.2 22.6 25.4 23.4L19.4 29.4C19 29.8 18.6 30 18 30Z",
    fill: "#425466"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30C29.4 30 29 29.8 28.6 29.4L22.6 23.4C21.8 22.6 21.8 21.4 22.6 20.6C23.4 19.8 24.6 19.8 25.4 20.6L31.4 26.6C32.2 27.4 32.2 28.6 31.4 29.4C31 29.8 30.6 30 30 30Z",
    fill: "#425466"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d392cd6eccd4adb47f919e738844a3b7.svg";
export { ForwardRef as ReactComponent };